import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import backIcon from "../assets/back.png";
export default function Navbar() {
  const navigate = useNavigate();
  const [isHover, setIsHover] = useState(false);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark"
      style={{
        borderBottom: "1px solid grey",
      }}
    >
      {" "}
      <div className="container-fluid">
        <div className="d-flex align-items-center gap-3">
          <button
            onClick={() => navigate("/")}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            style={{
              backgroundColor: isHover ? "#e1ebff" : "#f5f5f5",
              border: "none",
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "0.3s",
            }}
          >
            <img
              src={backIcon}
              alt="Back"
              style={{
                width: "14px",
                height: "14px",
              }}
            />
          </button>
          <a className="navbar-brand text-dark" href="/landing">
            Home
          </a>
        </div>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          {/* ✅ LEFT SIDE MENU */}
          <ul className="navbar-nav me-auto">
            {/* ✅ Master Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle text-dark"
                href="#"
                id="masterDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Master
              </a>
              <ul className="dropdown-menu" aria-labelledby="masterDropdown">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/robatmaster")}
                  >
                    Robot Master
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/feedbacktemplatemaster")}
                  >
                    Feedback Template Master
                  </button>
                </li>
                <button
                  className="dropdown-item"
                  onClick={() => navigate("/EventMaster")}
                >
                  Event Master
                </button>
              </ul>
            </li>
          </ul>

          {/* ✅ RIGHT SIDE LOGOUT BUTTON */}
        </div>
      </div>
    </nav>
  );
}
